import React from 'react'
import { Link } from '@mui/material'
import Head from 'next/head'

const Index = () => {
    return (
        <>

        <Head>
    <title>Privacy Policy | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Privacy Policy, Data Collection, Personal Information, Data Security, SSL, User Privacy, School of Our Divine Infinite Being"
    ></meta>
    <meta
      property="og:title"
      content="Our Commitment to Your Privacy | School of Our Divine Infinite Being"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/privacy_policy_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A lock icon symbolizing the secure and private handling of user data as detailed in the Privacy Policy for the School of Our Divine Infinite Being."
    ></meta>
    <meta
      property="og:description"
      content="Read the official Privacy Policy for the School of Our Divine Infinite Being. Learn how we collect, use, and protect your personal information to ensure your privacy and security on our site."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/privacypolicy"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/privacy_policy_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A lock icon symbolizing the secure and private handling of user data as detailed in the Privacy Policy for the School of Our Divine Infinite Being."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/privacypolicy"
    ></meta>
    <meta
      name="twitter:title"
      content="Our Commitment to Your Privacy | School of Our Divine Infinite Being"
    ></meta>
    <meta
      name="twitter:description"
      content="Read the official Privacy Policy for the School of Our Divine Infinite Being. Learn how we collect, use, and protect your personal information to ensure your privacy and security on our site."
    ></meta>
       <link rel="canonical" href="https://www.divineinfinitebeing.com/privacypolicy"/>
</Head>
            <div className="copyrightMainWrpr">
                <div className="commonWidthDiv">
                    <div className="mainHeader"><h1>Privacy Policy</h1></div>

                    <p>
                        Protecting your private information is a priority of the School of Our Divine Infinite Being. This Statement of Privacy applies to <Link href='https://www.divineinfinitebeing.com/'>https://www.divineinfinitebeing.com/</Link>  and governs data collection and usage. The Company website is an informational and ecommerce site; by using the Company website you consent to the data practices described in this statement.

                        This Privacy Policy applies only to the School of Our Divine Infinite Being Sites. It does not apply to any other companies or third-party websites to which School of Our Divine Infinite Being is linked or is accessible. If the Site of School of Our Divine Infinite Being is left by following a link and visiting another site, it is done at the risk of the user. For this reason, it is advisable that users carefully read and review the privacy policies of those websites.

                    </p>

                    <h3>Collection of your Personal Information</h3>

                    <p>
                        The company may collect personally identifiable information, such as your name. If you purchase Company's products and services,  e collect billing and credit card information. This information is used to complete the purchase transaction. We may gather additional personal or non-personal information in the future.
                    </p>

                    <h3>Security of your Personal Information</h3>
                    <p>
                        To secure your personal information from unauthorized access, use, or disclosure, Company uses Payment Card Industry ("PCI") Compliant Servers and Software Secure business practices and policies. When personal information (such as a credit card number) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol.
                    </p>
                    <h3>Use of personal information</h3>
                    <p>
                        The company collects and uses your personal information to operate its website(s) and deliver the services you have requested.

                        The company may also use your personally identifiable information to inform you of other products or services available from Company and its affiliates. The company may also contact you via surveys to conduct research about your opinion of current services or of potential new services that may be offered. The company does not sell, rent or lease its customer lists to third parties.

                        Company will disclose your personal information, without notice, only if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on Company or the site; (b) protect and defend the rights or property of Company; and, (c) act under exigent circumstances to protect the personal safety of users of Company, or the public.

                        The company may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to Company, and they are required to maintain the confidentiality of your information.

                    </p>
                    <h3>Third-Party advertising and Content</h3>
                    <p>
                        The company may keep track of the websites and pages our users visit within the Company, in order to determine what Company services are the most popular. This data is used to deliver customized content and advertising within the Company to customers whose behavior indicates that they are interested in a particular subject area.

                        The company encourages you to review the privacy statements of websites you choose to link to from the Company so that you can understand how those websites collect, use, and share your information. The company is not responsible for the privacy statements or other content on websites outside the Company website.

                    </p>
                    <h3>Use of this Web Site</h3>
                    <p>
                        The design of this Page, including all text, graphics, information, and content are protected by copyright and trademark laws and may not be displayed, performed, distributed, or in any way used for public or commercial purposes except as permitted in this policy. Any unauthorized use of information or materials may violate copyright and/or trademark laws, privacy or publicity laws, and other applicable laws and regulations. School of Our Divine Infinite Being reserves the right to prosecute any violators of its intellectual property rights.
                    </p>
                    <h3>Trademarks</h3>
                    <p>
                        Trademarks, trade names, and logos used on this Page are registered or unregistered trademarks, trade names, and logos of School of Our Divine Infinite Being and affiliates. No information contained on this Page should be considered to grant any right to use any trademarks, trade names, or logos displayed on this Page. Only written permission by School of Our Divine Infinite Being may grant the use of trademarks, trade names, and logos contained on this Site.
                    </p>
                    <h3>Online Forums</h3>
                    <p>
                        School of Our Divine Infinite Being may at times offer online forums on the Site. Any information, material, idea, or opinion included or expressed on these forums does not necessarily represent those of School of Our Divine Infinite Being. Any use of the forums will be at the sole risk of the user and will be subject to the Terms of Use of the School of Our Divine Infinite Being Site.
                    </p>
                    <h3>Use of Cookies</h3>
                    <p>
                        The Company website may use "cookies" to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.

                        The purpose of a cookie is to tell the website to recall your specific information on subsequent visits. When you return to the same Company website, the information you previously provided can easily be retrieved, which allows you to use the Company features that you customized. You may also update your personal information anytime by logging on to your account.

                        You have the ability to accept or decline cookies. If you choose to decline cookies, you may not be able to fully experience the interactive features of the Company services or website you visit.

                    </p>
                    <h3>Opt-Out & Unsubscribe</h3>
                    <p>
                        We respect your privacy and give you an opportunity to opt out of receiving announcements of certain information. Users may opt out of receiving any or all communications from the Company by contacting us using the information provided in the “Contact Information” section provided below.
                    </p>
                    <h3>Children Under Thirteen</h3>
                    <p>
                        The company does not knowingly collect personally identifiable information from children under the age of thirteen. If you are under the age of thirteen, you must ask your parent or guardian for permission to use this website.
                    </p>

                    <h3>Mature Audiences</h3>
                    <p>
                        Some content may not be suitable for children under 18. There may be times when events are listed that are intended for mature audiences. We will not be responsible for the misuse of content by minors and those under the age of 13 should use this site only under adult supervision.
                    </p>

                    <h3>E-Commerce and Secure Server</h3>
                    <p>
                        Industry-standard security techniques are in place to protect users against loss, misuse, or alteration of information collected from users on the School of Our Divine Infinite Being Site. Any personally identifiable information that users have submitted is stored on secured servers that protect against any attempts of outside parties to gain unauthorized access. Software is in place which encrypts personal information transmitted through this Site by users. While School of Our Divine Infinite Being has made all necessary precautions to avoid unauthorized access to data, School of Our Divine Infinite Being cannot and will not be held responsible for unauthorized access.
                    </p>
                    <h3>Retention Period (Of Your Information)</h3>
                    <p>
                        We may retain your Personal Data as long as you continue to use our Services. You can discontinue our services and close your account by contacting us at any time. However, we can retain your Personal Data for an additional period as is permitted or required under applicable laws. When your Personal Data is deleted, it may persist on backup or archival media for an additional period of time.
                    </p>
                    <h3>Changes to this Statement</h3>
                    <p>
                        The company will occasionally update this Statement of Privacy to reflect company and customer feedback. The company encourages you to periodically review this Statement to be informed of how Company is protecting your information.
                    </p>
                    <h3>Contact Information</h3>
                    <p>
                        The company welcomes your questions or comments regarding this Statement of Privacy. If you believe that Company has not adhered to this Statement, please contact Company at:
                    </p>




                    <h4>Reach us at:</h4>
                    <p className='emailWrprFooter'>
                        <span>Email:</span>
                        <a href="mailto:support@divineinfinitebeing.com" target="_top">
                            support@divineinfinitebeing.com
                        </a>
                    </p>
                    <p>
                        <span>Phone:</span>
                        <a href="tel:208.440.7609" target="_top">
                            208.440.7609
                        </a>
                    </p>

                </div>

            </div>
        </>
    )
}

export default Index